import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=6515dcbc&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=6515dcbc&prod&lang=less&scoped=true&"
import style1 from "../assets/pc-auth.less?vue&type=style&index=1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515dcbc",
  null
  
)

export default component.exports